import { render } from "./DsArrowDown.vue?vue&type=template&id=159f7066&scoped=true"
import script from "./DsArrowDown.vue?vue&type=script&lang=js"
export * from "./DsArrowDown.vue?vue&type=script&lang=js"

import "./DsArrowDown.vue?vue&type=style&index=0&id=159f7066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159f7066"]])

export default __exports__